<template>
  <div class="page-wrapper">
    <h1 class="title-screen">{{ adminText('workflowsAll.new_attendee_field_translation_e9ea8da', 'New attendee field translation') }}</h1>
    <div>
      <h3>{{ adminText('workflowsAll.select_language_daea52c', 'Select language') }}</h3>
      <p>
        {{ adminText('workflowsAll.select_a_language_for_which_you_are_creating__a9cf79e', 'Select a language for which you are creating a translation. You can choose your preferred language in your account settings.') }}
      </p>
      <v-autocomplete
        v-model="selectedLanguage"
        :items="languageItems"
        item-text="name"
        item-value="id"
        box
        :label="adminText('workflowsAll.language_89b86ab', 'Language')"
        @change="selectLanguague($event)"
      />
    </div>
    <div v-if="selectedLanguage" class="add-translation">
      <h3>{{ adminText('workflowsAll.add_your_translations_f18f1c7', 'Add your translations') }}</h3>
      <p>{{ adminText('workflowsAll.translate_your_event_title_and_attendee_field_be557ef', 'Translate your event title and attendee fields labels') }}</p>
      <div v-for="(attendeeField, index) in this.attendeeFields" :key="index">
        <div class="field">
          <div class="field-name">{{ attendeeField }}</div>
          <text-field v-model="form[attendeeField]" :label="attendeeField" class="field-input" />
        </div>
      </div>
    </div>
    <div class="buttons">
      <main-button flat :text="adminText('workflowsAll.cancel_1507c40', 'CANCEL')" @click="() => this.$emit('cancel')" />
      <main-button :text="adminText('workflowsAll.save_508156a', 'SAVE')" @click="submit()" />
    </div>
  </div>
</template>

<script>
import WorkflowDisplay from '@/admin-i18n/workflows-all-display'
import { createOrUpdateEventTranslation } from './../../http'
export default {
  mixins: [WorkflowDisplay],
  name: 'new-translation',
  props: {
    attendeeFields: {
      default: [],
      type: Array,
    },
    eventId: {
      default: null,
      type: String,
    },
    restrictLanguages: {
      default: false,
      type: Boolean,
    },
  },
  data() {
    return {
      allLanguages: require('../../assets/languages.json'),
      selectedLanguage: '',
      translationData: {},
      form: {},
      isoLanguageShort: '',
    }
  },
  computed: {
    languageItems() {
      let displayNames
      if (this.isAdminLocalization) {
        const locale = this.$adminLocale()
        try {
          if (typeof Intl !== 'undefined' && typeof Intl.DisplayNames === 'function') {
            displayNames = new Intl.DisplayNames([locale], { type: 'language' })
          }
        } catch (_) { /* Original names and known language translations remain available. */ }
      }

      return this.getLanguagesList().map(original => {
        const entry = Object.entries(this.allLanguages).find(([, language]) => language.name === original)

        return { id: original, name: this.languageCaption(entry && entry[0], original, displayNames) }
      })
    },
  },
  methods: {
    languageCaption(code, original, displayNames) {
      if (!this.isAdminLocalization) return original
      if (displayNames && code) {
        try {
          const caption = displayNames.of(code)
          if (caption && caption !== code) return caption
        } catch (_) { /* Unknown language codes keep their original names. */ }
      }
      switch (code) {
      case 'hr': return this.adminText('fieldTypes.languageCroatian', 'Croatian')
      case 'en': return this.adminText('fieldTypes.languageEnglish', 'English')
      default: return original
      }
    },
    async submit() {
      try {
        this.translationData[this.isoLanguageShort] = { ...this.form }
        const eventTranlsationSaved = await createOrUpdateEventTranslation(
          Number(this.eventId),
          this.translationData,
        )
        if (eventTranlsationSaved) {
          this.$emit('saved')
        }
      } catch (e) {
        console.error(e)
      }
    },
    selectLanguague(language) {
      let selectedLanguage
      Object.entries(this.allLanguages).find(([key, value]) => {
        if (value.name === language) {
          return (selectedLanguage = key)
        }
      })
      this.isoLanguageShort = selectedLanguage
    },
    getLanguagesList() {
      if (this.restrictLanguages) {
        return ['Croatian', 'English']
      }

      const list = []
      Object.entries(this.allLanguages).forEach(([key, value]) => {
        list.push(value.name)
      })

      return list
    },
  },
}
</script>

<style scoped>
.add-icon {
  width: 0.75rem;
  height: 0.75rem;
  margin-right: 0.5rem;
}
.screen-title {
  padding: 0 !important;
  margin-bottom: 2.25rem !important;
}
h3 {
  font-family: 'Raleway';
  font-style: normal;
  font-weight: 600;
  font-size: 20px;
  color: #ff4c00;
  margin-bottom: 12px;
}
p {
  font-family: 'Source Sans Pro';
  font-style: normal;
  font-weight: 400;
  font-size: 18px;
  color: #979797;
  margin-bottom: 24px;
}
.field {
  display: flex;
  flex-direction: row;
  column-gap: 3rem;
  align-items: center;
}
.field-name {
  flex-basis: 25%;
}
.field-input {
  flex-basis: 75%;
}
.add-translation {
  margin-top: 4.5rem;
}
.buttons {
  display: flex;
  margin-top: 2rem;
  justify-content: space-between;
}
@media screen and (max-width: 800px) {
  .page-wrapper {
    margin-top: 1.5rem;
  }
}
</style>
